import React, {useCallback} from 'react';
import {Card, Checkbox, Description, Header, InfoRow, Price, Title} from '../styled';
import {Divider, Text, Tooltip, UsersIcon} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';
import {VismaUpsellProduct} from 'common/types/store/threeSixtyTypes';
import {convertToKroner} from 'utils/number';
import {PriceContainer, PriceUnit} from './styled';

interface UpsellCheckBoxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
	data?: VismaUpsellProduct | null;
	totalCount?: number;
}

const UpsellCheckBox: React.FC<UpsellCheckBoxProps> = ({
	checked,
	onChange,
	data,
	totalCount,
}) => {
	const [t] = useTranslation();

	if (data === null || data === undefined) {
		return null;
	}

	return (
		<Card
			checked={checked}
			onClick={() => onChange(!checked)}
			tabIndex={0}
			role="checkbox"
			aria-checked={checked}
		>
			<div>
				<Header>
					<Title>{data?.product_name}</Title>
					<Checkbox
						checked={checked}
						onChange={e => onChange(e.target.checked)}
						onClick={e => e.stopPropagation()}
					/>
				</Header>
				<PriceContainer>
					<Price>
						{convertToKroner(data?.price, false, true)}
					</Price>
					<PriceUnit>{t('/mth')}</PriceUnit>
				</PriceContainer>
				<Divider style={{margin: '8px 0px'}}/>
				<InfoRow>
					<Text>
						{t('Comission: {{commission}}', {commission: convertToKroner(data?.commission, false)})}
					</Text>
					<Tooltip
						text={<Text>{t('Potential users / All users')}</Text>}
					>
						<span style={{display: 'flex', alignItems: 'center'}}>
							<span
								role="img"
								aria-label="users"
								style={{display: 'inline-flex', marginRight: '6px'}}
							>
								<UsersIcon />
							</span>
							<Text>
								{`${data?.missing_count || 0}/${totalCount || 0}`}
							</Text>
						</span>
					</Tooltip>
				</InfoRow>
				<Description>
					<Text color="textSecondary" variant="body">
						{data?.sale_pitch || t('No description available.')}
					</Text>
				</Description>
			</div>
		</Card>
	);
};

export default UpsellCheckBox;
